/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Psychology16Inputs */

const en__field__enum_studyprograms_study_psychology16 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Psychology16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Psychology`)
};

const de__field__enum_studyprograms_study_psychology16 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Psychology16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Psychologie`)
};

/**
* | output |
* | --- |
* | "Psychology" |
*
* @param {_Field__Enum_Studyprograms_Study_Psychology16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_psychology16 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Psychology16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Psychology16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_psychology16(inputs)
	return de__field__enum_studyprograms_study_psychology16(inputs)
});
export { _field__enum_studyprograms_study_psychology16 as "_field__enum_studyPrograms_STUDY_PSYCHOLOGY" }